/**
 * eventLog.ts — Single source of truth for product event instrumentation.
 * Writes to `event_log` table (DB-backed).
 * Optionally mirrors to Mixpanel for external analytics.
 */
import { supabase } from '@/integrations/supabase/client';
import { track as mixpanelTrack } from './mixpanel';

export interface EventProps {
  project_id?: string;
  [key: string]: unknown;
}

/**
 * Log a product event to the event_log table and mirror to Mixpanel.
 * Fails silently — never blocks the UI.
 */
export async function logEvent(
  eventName: string,
  props: EventProps = {}
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user?.id) return;

    const { project_id, ...rest } = props;

    await (supabase.from('event_log' as any) as any).insert({
      event_name: eventName,
      user_id: user.id,
      project_id: project_id || null,
      properties: rest,
    });

    // Mirror to Mixpanel (optional, non-blocking)
    mixpanelTrack(eventName, { ...props, source: 'event_log' });
  } catch (e) {
    console.warn('[eventLog] Failed:', eventName, e);
  }
}
